import { useReduxState } from 'hooks';
import { Avatar, RichTextValue } from 'components/common';
import { Box, BoxEmpty, BoxRow } from 'components/common/box';

interface Props {
  selectedAchievement: {
    templateItems: {
      order: number;
      text: string;
    }[];
    type: string;
  };
}

const AchievementTemplateImportPreview = ({ selectedAchievement }: Props) => {
  const { messages, theme } = useReduxState();

  if (!selectedAchievement) return null;

  return (
    <Box
      padding={0}
      title={
        {
          conversation: messages.commonQuestions,
          tasklist: messages.tasks
        }[selectedAchievement?.type]
      }
    >
      {selectedAchievement?.templateItems.length ? (
        selectedAchievement.templateItems.map((item, i) => (
          <BoxRow key={item.order}>
            <div className="content">
              <div className="number">
                <Avatar size="24px" fontSize="1.4rem" padding="2px 0">
                  {i + 1}
                </Avatar>
              </div>
              <div className="text">
                <RichTextValue html={item.text} />
              </div>

              <style jsx>{`
                .content {
                  align-items: flex-start;
                  display: flex;
                  padding: 5px 0;
                }
                .number {
                  flex-grow: 0;
                  flex-shrink: 0;
                  margin-right: 15px;
                }
                .text {
                  color: ${theme.textColorLight};
                  font-size: 1.5rem;
                  font-weight: 600;
                  line-height: 1.4;
                }
              `}</style>
            </div>
          </BoxRow>
        ))
      ) : (
        <BoxEmpty text={messages.achievementTemplateEmpty} />
      )}
    </Box>
  );
};

export default AchievementTemplateImportPreview;
